import 'promise-polyfill'
import Vue from 'vue'
import axios from 'axios'
import vueAxios from 'vue-axios'
import VueFormulate from '@braid/vue-formulate'
import VueMixpanel from 'vue-mixpanel'
import VueMeta from 'vue-meta'
// import VueGtag from "vue-gtag"
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { API_URL } from '@/helpers/axios'

import '@/plugins/register-components'
import '@/plugins/register-svgs'
import '@/plugins/browserDetection'

// import FormulateCheckbox from '@/components/FormulateCheckbox'
axios.defaults.baseURL = API_URL
axios.interceptors.response.use(response => response, error => {
  if (error.response.status === 401) {
    store.dispatch('Auth/logoutUser')
  }

  return error
})

Vue.use(vueAxios, axios)
Vue.use(VueMeta)

// Uncomment for Google Analytics, and replace YOUR_ID with your actual google analytics ID.
// Vue.use(VueGtag, {
//   config: { id: "YOUR_ID" }
// })

Vue.use(VueFormulate, {
  library: {
    customCheckbox: {
      classification: 'checkbox',
      component: 'FormulateCheckbox'
    }
  }
})

Vue.use(VueMixpanel, {
  token: "b344fc88c6f335526f3598fc9805d363",
  config: {
    debug: true
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
